export interface BettingTabClickedEventProperties {
  tabName: string
}

export enum BettingScreens {
  BETTING = 'Betting',
}

export enum BettingTabs {
  OVERVIEW = 'Overview',
  MATCHUP = 'Matchup',
  HIT_RATE = 'Hit Rate',
  ODDS = 'Odds',
}
